import React, {useState, useEffect, useRef, useContext} from 'react';
import Navigation from '../Navigation/Navigation';
import {
  ClientWidthContext,
  ModalContext,
  ModalDispatchContext,
} from '../Context/ApplicationContextProvider';
import {eventEmitter} from '../../common/baseData';

function normalizeSectionTree(data) {
  const value = data && typeof data === 'object' ? data : {};
  return {
    rootSections: Array.isArray(value.rootSections) ? value.rootSections : [],
    sections: Array.isArray(value.sections) ? value.sections : [],
    popularSections: Array.isArray(value.popularSections) ? value.popularSections : [],
    popularLinks: Array.isArray(value.popularLinks) ? value.popularLinks : [],
    promotions: Array.isArray(value.promotions) ? value.promotions : [],
  };
}

function DropdownNavigation(props) {
  const modals = useContext(ModalContext);
  const dispatchModal = useContext(ModalDispatchContext);
  const clientWidth = useContext(ClientWidthContext);

  const {sticky, page} = {...props};
  const [hoveredRootSectionId, setHoverOnRootSectionId] = React.useState(null);
  const [sectionTreeHeight, setSectionTreeHeight] = React.useState(null);

  const [sectionTreeData, setSectionTreeData] = useState(normalizeSectionTree(window.sectionTree));
  const [heavyLoaded, setHeavyLoaded] = useState(
    Boolean(window.sectionTree && Array.isArray(window.sectionTree.sections) && window.sectionTree.sections.length)
  );

  const [hasSubsection, setHasSubsection] = useState(false);
  const sectionClass = sticky  ? 'top-[1px] left-0' : 'top-0 left-[-20px] overflow-hidden';

  const [showNavigation, setShowNavigation] = React.useState(
    modals.includes('navigation'));
  const hasSubsectionOrLoading = hasSubsection ||
    (!heavyLoaded && Number(hoveredRootSectionId));

  // Условие для sectionCheckedClass
  const sectionCheckedClass = (() => {
    if (sticky && Number(hoveredRootSectionId) && hasSubsectionOrLoading) {
      return 'w-full'; // sticky, раздел выбран, есть подкатегории
    }
    if (Number(hoveredRootSectionId) && hasSubsectionOrLoading && !sticky) {
      return 'w-[calc(100%+40px)]'; // Не sticky, раздел выбран, есть подкатегории
    }
    if (Number(hoveredRootSectionId) && !hasSubsection && !sticky) {
      return 'w-fit'; // Не sticky, раздел выбран, нет подкатегорий
    }
    return 'w-fit'; // По умолчанию
  })();

  useEffect(() => {
    setShowNavigation(modals.includes('navigation'));
  }, [modals]);

  useEffect(() => {
    if (!showNavigation || heavyLoaded) return;

    const url = (typeof window.sectionTreeHeavyDataUrl === 'string' && window.sectionTreeHeavyDataUrl.length)
      ? window.sectionTreeHeavyDataUrl
      : '/local/components/v2/section.tree/ajax.php?iblockId=14';

    if (!window.sectionTreeHeavyDataPromise) {
      window.sectionTreeHeavyDataPromise = fetch(url, {credentials: 'same-origin'})
        .then(response => {
          if (!response.ok) throw new Error('Section tree heavy request failed with status ' + response.status);
          return response.json();
        })
        .catch(error => {
          window.sectionTreeHeavyDataPromise = null;
          throw error;
        });
    }

    window.sectionTreeHeavyDataPromise
      .then(payload => {
        if (!payload || payload.error || !payload.data) return;
        const heavyData = normalizeSectionTree(payload.data);
        setSectionTreeData(prev => ({...prev, ...heavyData}));

        setHeavyLoaded(true);
      })
      .catch(console.error);
  }, [showNavigation, heavyLoaded]);

  useEffect(() => {
    eventEmitter.on('closeNavigation', dropCheckedSection);

    return () => {
      eventEmitter.off('closeNavigation', dropCheckedSection);
    }
  }, []);

  function dropCheckedSection() {
    setHoverOnRootSectionId(null);
  }

  return (
    <div className={`${showNavigation ? 'opacity-100 z-10 pointer-events-auto' : 'opacity-0 z-0 pointer-events-none'} transition-all relative self-end w-full max-w-[1600px] m-auto`}
         onMouseLeave={() => {
           dispatchModal({type: 'hide', modalType: 'navigation'});
         }}>
      <section id="navigation-root"
               className={`absolute ${sectionCheckedClass} p-5 pt-6 ${sectionClass} right-0 flex gap-12 z-30 bg-white`}>
        <Navigation setHeight={setSectionTreeHeight}
                     {...sectionTreeData}
                     hoveredRootSectionId={hoveredRootSectionId}
                     sectionTreeHeight={sectionTreeHeight}
                     sectionsLoading={!heavyLoaded}
                     setHasSubsection={setHasSubsection}
                     setHoverOnRootSectionId={setHoverOnRootSectionId}/>
      </section>
    </div>
  );
}

export default DropdownNavigation;